import Carousel from "./carousel";

export default class Lightbox {
  constructor(node) {
    this.element = node;
    this.selectedImage;

    this.lightboxModal = this.element.querySelector(".js-lightbox-modal");
    this.imagesInCarousel = Array.from(this.lightboxModal.querySelectorAll(".swiper-slide"));

    this.images = Array.from(this.element.querySelectorAll(".js-lightbox-image"));
    this.downloadElement = this.element.querySelector(".js-lightbox-download");

    this.initialize();
  }

  initialize() {
    const lightboxOptions = {
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
      },
    };

    this.carousel = new Carousel(this.lightboxModal, lightboxOptions);

    this.lightboxModal.addEventListener("show.bs.modal", ({ relatedTarget }) => {
      this.selectedImage = relatedTarget.querySelector(".js-lightbox-image");
      this.selectedIndex = this.images.indexOf(this.selectedImage);

      this.carousel.swiper.slideTo(this.selectedIndex, false, false);
      this.downloadElement.href = relatedTarget.dataset.downloadUrl;
    });

    this.carousel.swiper.on("slideChange", () => {
      const carouselContext = this.carousel.swiper.slides[this.carousel.swiper.realIndex];

      if (carouselContext) {
        const downloadLink = carouselContext.dataset.downloadUrl;

        this.downloadElement.href = downloadLink;
      }
    });
  }
}
